import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { CoopTrasportoFormValidators } from './validators/coop-trasporto.form-validators';
import { manageSchedaDisabled, manageScObbl } from '../common/helper/scheda-settore.helper';
import { CoopTrasportoFormListeners } from './listeners/coop-trasporto.form-listeners';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { DatiIdentificativiFormService } from '../../dati-identificativi/dati-identificativi-form.service';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { setInitialTipoSezEnte } from '../../../helpers/form-store.helpers';
import { formPaths } from '@shared/constants/form-paths.const';

@Injectable()
export class SchedaCoopTrasportoFormService extends BaseRevisioneFormService {
    isDisabled$: Observable<boolean>;

    constructor(protected datiIdentificativiService: DatiIdentificativiFormService) {
        super(undefined, undefined, datiIdentificativiService);
    }

    override get dependencyPaths(): Set<string> {
        return new Set([
            // Dati identificativi
            `${formPaths.datiIdentificativi}.my_TipoSezEnte`,

            // Scheda altre coop
            `${formPaths.schedaAltreCoop}.my_CkAltreCoopAllegaSchedaTrasporto`,
            `${formPaths.schedaAltreCoop}.my_ScAltreCoopObbl`,

            // Scheda coop sociali
            `${formPaths.schedaCoopSociali}.my_ScSocObbl`,

            // Scheda coop edilizie
            `${formPaths.schedaCoopEdil}.my_ScEdilObbl`,

            // Scheda coop consumo
            `${formPaths.schedaCoopConsumo}.my_ScConsumoObbl`,

            // Scheda coop PDL
            `${formPaths.schedaCoopPDL}.my_ScPDLObbl`,

            // Scheda coop agricole
            `${formPaths.schedaCoopAgricole}.my_ScAgricoleObbl`,

            // Scheda coop pesca
            `${formPaths.schedaCoopPesca}.my_ScPescaObbl`,

            // Scheda coop fidi
            `${formPaths.schedaCoopFidi}.my_ScCoopFidiObbl`,

            // Scheda coop dettaglianti
            `${formPaths.schedaCoopDettaglianti}.my_ScCoopDettagliObbl`,
        ]);
    }

    override initListener(): void {
        new CoopTrasportoFormListeners(this._form, this.store).setListeners();
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_SchedaCoopTrasporto: this.fb.group({
                        my_ModoDiAssociazione: '',
                        my_ScTrasportoObbl: '',
                        my_GroupTrasporto: '',
                        my_ServiziOffertiAiSoci: '',
                        my_CkPossideOfficine: '',
                        my_CkGestisceDistributoriCarburante: '',
                        my_CkGestisceRadioTaxi: '',
                        my_TitolareMezziLicenze: '',
                        my_MezziLicenzeConferitiSoci: '',
                        my_ScTraspAltreOsserv: '',
                        my_CkAltriServiziOffertiAiSoci: '',
                    }),

                    my_DatiIdentificativi: this.fb.group({
                        my_TipoSezEnte: '',
                    }),

                    my_SchedaCoopAltreCoop: this.fb.group({
                        my_CkAltreCoopAllegaSchedaTrasporto: '',
                        my_ScAltreCoopObbl: '',
                    }),

                    my_SchedaCoopSociali: this.fb.group({
                        my_ScSocObbl: '',
                    }),

                    my_SchedaCoopEdil: this.fb.group({
                        my_ScEdilObbl: '',
                    }),

                    my_SchedaCoopConsumo: this.fb.group({
                        my_ScConsumoObbl: '',
                    }),

                    my_SchedaCoopPDL: this.fb.group({
                        my_ScPDLObbl: '',
                    }),

                    my_SchedaCoopAgricole: this.fb.group({
                        my_ScAgricoleObbl: '',
                    }),

                    my_SchedaCoopPesca: this.fb.group({
                        my_ScPescaObbl: '',
                    }),

                    my_SchedaCoopFidi: this.fb.group({
                        my_ScCoopFidiObbl: '',
                    }),

                    my_SchedaCoopDettaglianti: this.fb.group({
                        my_ScCoopDettagliObbl: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: CoopTrasportoFormValidators,
            }
        );
    }

    protected override afterFormInitialize(): void {
        this._manageDeactivation();
        manageScObbl(this.datiIdentificativiFormService, this._form, `${formPaths.schedaCoopTrasporto}.my_ScTrasportoObbl`);
    }

    protected override beforePopulateForm(myVerbale: MyVerbale) {
        setInitialTipoSezEnte(myVerbale, this.store);
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScTrasportoObbl);
    }
}
